.profileMenuButton {
	padding: 0;
}

.profileIcon {
	background: white;
}

.userMenu {
	width: 200px;
	display: flex;
	flex-direction: column;
	font-size: 15px;
}

.menuInfoArea {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	border-bottom: 1px solid rgb(179, 179, 179);
	padding: 20px 20px 10px 20px;
}

.menuInfoAreaDetails {
	width: 100%;
	max-width: 100%;
	min-width: 0;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	text-align: center;
}

.infoAreaText,
.roleText,
.name {
	display: block;
	max-width: 100%;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.roleText {
	color: #6f6f6f;
	font-size: 14px;
	line-height: 1.6;
	font-weight: 400;
}

.name {
	font-weight: 700;
	font-size: 20px;
	line-height: 1.4;
	color: #000000;
}

.logoutButton:global(.MuiMenuItem-root) {
	border-top: 1px solid rgb(179, 179, 179);
}
